import React, { useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./GuideSection.css";

const GuideSection = ({ id, title, children, expanded, onChange }) => {
  const containerRef = useRef(null);
  const wasExpanded = useRef(false);

  useEffect(() => {
    if (expanded === id && !wasExpanded.current && containerRef.current) {
      // Small delay to allow accordion to expand first
      setTimeout(() => {
        const headerElement = containerRef.current?.querySelector(`#${id}-header`);
        if (headerElement) {
          headerElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
        }
      }, 100);
      wasExpanded.current = true;
    } else if (expanded !== id) {
      wasExpanded.current = false;
    }
  }, [expanded, id]);

  return (
    <Box className="mb-3" ref={containerRef}>
      <Accordion
        expanded={expanded === id}
        onChange={onChange(id)}
        className="guide-accordion"
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`${id}-content`}
          id={`${id}-header`}
        >
          <Typography variant="h5" color="primary">
            {title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box className="guide-content">{children}</Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default GuideSection;

